import React from 'react'
import '.././assets/css/portfolio.css'
import ProjectList from './ProjectList'
function Portfoliopage() {
  return (
    <>
    <div className='portfolio-head'>
       <h2>
        A Collection of My <span>Best Work</span>
       </h2>
    </div>

<div className="project-sec">
  <ProjectList
    title="BigXTech — IT Services & Product Company"
    url="https://bigxtech.com/"
    desc="A fully responsive company website with service pages, product listings, business overview, and custom UI elements for startup branding."
    skills={["HTML", "CSS", "JavaScript", "Bootstrap" , "PHP" ,"MySQL" , "jQuery"]}
  />
</div>

<div className="project-sec">
  <ProjectList
    title="ZenoConceal "
    url="https://zenoconceal.com/"
    desc="A clean and simple online tool that lets users hide, blur, or mask sensitive text and images. Designed for quick demos and safe content sharing."
    skills={["HTML", "CSS", "JavaScript", "Bootstrap", "PHP", "Mysql"]}
  />
</div>

  <div className="project-sec">
  <ProjectList
    title="SmartQR Tech — QR Generator Platform"
    url="https://smartqrtech.com/"
    desc="A fast and modern QR code generator where users can create dynamic and static QR codes. Includes real-time preview, download options, and custom styling features."
    skills={["HTML", "CSS", "JavaScript", "Bootstrap",  "EmailJS"]}
  />
</div>

  <div className="project-sec">
  <ProjectList
    title="RajShah Photography — Photography Website"
    url="https://rajshahphotography.com/"
    desc="At Raj Shah Photography, we don’t just take pictures—we preserve your story with creativity, passion, and perfection. Every click is a moment frozen in time, every frame a reflection of emotions."
    skills={["HTML", "CSS", "JavaScript", "Bootstrap",  "EmailJS"]}
  />
</div>



<div className="project-sec">
  <ProjectList
    title="AtmanirbharAcademy — Learning Platform"
    url="https://atmanirbharacademy.com/"
    desc="An educational platform offering courses, student resources, and instant form submissions. Designed with clean UI and optimized performance."
    skills={["HTML", "CSS", "JavaScript", "Bootstrap", "EmailJS"]}
  />
</div>

<div className="project-sec">
  <ProjectList
    title="OfficeWallah — Online Form + Google Sheet Sync"
    url="https://officewallah.in/"
    desc="A complete form system where user submissions automatically save to a connected Google Sheet using Apps Script and form validation."
    skills={["HTML", "CSS", "JavaScript", "Google Apps Script", "API Integration"]}
  />
</div>


    
    </>
  )
}

export default Portfoliopage
